<form class="form-popup" [formGroup]="formGroup">
  <div class="modal-body">
    <div class="row top10 vcenter">
      <div class="col-xs-4 text-right">
        <b>Select Qual Task:</b>
      </div>
      <div class="col-xs-8">
        <aims-lookup style="width:100%"
                     name="SelectQualTaskPrerequisite"
                     id="selectQualTaskPrerequisite"
                     [gridText]="'Select a Task as a Prerequiste to Task: ' + qualTaskDesc"
                     [values]="qualTaskPuValues | async"
                     [idPropertyName]="'qualTaskId'"
                     [displayPropertyName]="'qtDesc'"
                     formControlName="preReqQualTaskId"
                     [columnsInGrid]="qualificationTaskLookupColumns">
        </aims-lookup>
      </div>
    </div>
  </div>

</form>
